<!-- <div [ngClass]="{ containerMarginX: showOptions === false }"> -->
<div
  *ngIf="!commonService.isMovilSource.getValue() && showOptions"
  class="btn-menu pointer"
  (click)="commonService.colapseMenu()">
  <fa-icon icon="bars"></fa-icon>
</div>

<div class="tech-spacer mini-hidden"></div>
<div *ngIf="showOptions; else noShowOptions">
  <img
    id="LogoClient"
    class="logo-client m-4 pointer"
    [src]="logowhiteUrl"
    (click)="goToProfilePortfolio()"
  />
</div>
<div class="tech-spacer"></div>
<div>
  <tech-theme-selector></tech-theme-selector>
</div>
<div
  class="icon-bell pointer"
  [class.zero]="zeroNotifications"
  *ngIf="showOptions">
  <fa-icon [icon]="['fas', 'bell']" routerLink="/notifications"></fa-icon>
  <div class="icon-letter" *ngIf="Notifications !== 0">
    {{ Notifications }}
  </div>
</div>
<ng-template #noShowOptions>
  <img id="LogoClient" class="logo-client m-4" [src]="logowhiteUrl" />
</ng-template>
